import { render } from "./ChromaKey.vue?vue&type=template&id=3eb96b06&ts=true"
import script from "./ChromaKey.vue?vue&type=script&lang=ts"
export * from "./ChromaKey.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__